(function () {
  const WRAPPER_SELECTOR = '#boost-sd__filter-tree-wrapper, #boost-sd_filter-tree-mobile';
  const SLIDER_SELECTOR = '.boost-sd__filter-option-range-slider-slider';
  // FB#47: 記号（N/S/SA）を撤去し単語のみに。A/AB/B は先方の対応表待ちのため据え置き。
  const CONDITION_LABELS = {
    n: 'New',
    s: 'Unused',
    sa: 'Like new',
    a: 'A',
    ab: 'AB',
    b: 'B'
  };
  const observedWrappers = new WeakSet();

  let scheduled = false;

  function clampPercent(value) {
    return Math.min(100, Math.max(0, value));
  }

  function syncSlider(slider) {
    const sliderRect = slider.getBoundingClientRect();
    const handles = Array.prototype.slice.call(slider.querySelectorAll('.noUi-handle'));

    if (!sliderRect.width || handles.length < 2) {
      return;
    }

    const positions = handles
      .map(function (handle) {
        const handleRect = handle.getBoundingClientRect();
        const handleCenter = handleRect.left + handleRect.width / 2;

        return clampPercent(((handleCenter - sliderRect.left) / sliderRect.width) * 100);
      })
      .sort(function (a, b) {
        return a - b;
      });

    const start = positions[0].toFixed(3) + '%';
    const end = positions[positions.length - 1].toFixed(3) + '%';

    if (slider.style.getPropertyValue('--c-boost-range-start') !== start) {
      slider.style.setProperty('--c-boost-range-start', start);
    }

    if (slider.style.getPropertyValue('--c-boost-range-end') !== end) {
      slider.style.setProperty('--c-boost-range-end', end);
    }
  }

  function isProductConditionGroup(group) {
    if (
      group.id === 'pf_t_product_condition' ||
      group.id === 'pf_t_product_condition-toggle-target' ||
      group.querySelector('#pf_t_product_condition, #pf_t_product_condition-toggle-target')
    ) {
      return true;
    }

    const heading = group.querySelector('.boost-sd__filter-option-title, .boost-sd__filter-option-heading');

    if (!heading) {
      return false;
    }

    return heading.textContent.trim().toLowerCase() === 'product condition';
  }

  function isProductConditionLabel(label) {
    if (label.closest('#pf_t_product_condition, #pf_t_product_condition-toggle-target')) {
      return true;
    }

    const option = label.closest('.boost-sd__filter-option');
    if (
      label.classList.contains('boost-sd__filter-option-mobile-items-selected') &&
      option &&
      option.getAttribute('data-filteroptionid') === 'pf_t_product_condition'
    ) {
      return true;
    }

    const action = label.getAttribute('data-action') || '';
    if (action.indexOf('pf_t_product_condition.') === 0) {
      return true;
    }

    const button = label.closest('.boost-sd__filter-option-item-button');
    const ariaLabel = button ? button.getAttribute('aria-label') || '' : '';

    return ariaLabel.toLowerCase().indexOf('product condition is') !== -1;
  }

  function replaceConditionLabel(label) {
    if (!isProductConditionLabel(label)) {
      return;
    }

    const raw = label.textContent.trim();

    if (raw.indexOf(',') !== -1) {
      const parts = raw.split(',').map(function (k) {
        const key = k.trim().toLowerCase();
        return CONDITION_LABELS[key] || k.trim();
      });
      const joined = parts.join(', ');
      if (label.textContent !== joined) {
        label.textContent = joined;
      }
      return;
    }

    const key = raw.toLowerCase();
    const nextLabel = CONDITION_LABELS[key];

    if (!nextLabel) {
      return;
    }

    if (label.textContent !== nextLabel) {
      label.textContent = nextLabel;
    }
  }

  function replaceConditionLabels(wrapper) {
    const groups = wrapper.querySelectorAll(
      '.boost-sd__filter-option, .boost-sd__filter-option-label, .boost-sd__filter-option-itemwrapper'
    );

    groups.forEach(function (group) {
      if (!isProductConditionGroup(group)) {
        return;
      }

      group.querySelectorAll('.boost-sd__filter-option-item-label').forEach(replaceConditionLabel);
      group.querySelectorAll('.boost-sd__filter-option-mobile-items-selected').forEach(replaceConditionLabel);
    });

    wrapper.querySelectorAll('.boost-sd__filter-option-item-label').forEach(replaceConditionLabel);
    wrapper.querySelectorAll('.boost-sd__filter-option-mobile-items-selected').forEach(replaceConditionLabel);
  }

  function getFilterLabel() {
    var cfg = window.cBoostProductEnrich || {};
    return (cfg.filterToggleLabel && String(cfg.filterToggleLabel).trim()) || '';
  }

  function enforceMobileToolbarTitle() {
    var label = getFilterLabel();
    if (!label) {
      return;
    }
    document
      .querySelectorAll('#boost-sd_filter-tree-mobile .boost-sd__filter-tree-vertical-toolbar-middle')
      .forEach(function (el) {
        if (el.textContent.trim() !== label) {
          el.textContent = label;
        }
      });
  }

  // FB#50: フィルタードロワー（off-canvas）が実際に開いている間だけ <html> に印を付ける。
  // 常設サイドバー型のレイアウトを誤検知しないよう、off-canvas / モバイル用の
  // コンテナ配下に限定し、さらに実寸を持つ（＝画面に出ている）ことを条件にする。
  function syncMobileFilterState() {
    var open = false;
    var nodes = document.querySelectorAll(
      '#boost-sd__filter-tree-vertical--style-off-canvas .boost-sd__filter-tree-vertical,' +
      '#boost-sd_filter-tree-mobile .boost-sd__filter-tree-vertical'
    );

    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].classList.contains('boost-sd__filter-tree-vertical--hidden')) {
        continue;
      }

      var rect = nodes[i].getBoundingClientRect();
      if (rect.width > 0 && rect.height > 0) {
        open = true;
        break;
      }
    }

    document.documentElement.classList.toggle('c-mfilter-open', open);
  }

  function syncAll() {
    scheduled = false;
    syncMobileFilterState();
    enforceMobileToolbarTitle();
    replaceConditionLabels(document);
    document.querySelectorAll(SLIDER_SELECTOR).forEach(syncSlider);
  }

  function scheduleSync() {
    if (scheduled) {
      return;
    }

    scheduled = true;
    window.requestAnimationFrame(syncAll);
  }

  function observeWrapper(wrapper) {
    if (observedWrappers.has(wrapper)) {
      return;
    }

    observedWrappers.add(wrapper);

    const observer = new MutationObserver(scheduleSync);
    observer.observe(wrapper, {
      attributes: true,
      attributeFilter: ['style', 'class', 'aria-valuenow', 'aria-valuetext'],
      childList: true,
      subtree: true,
      characterData: true
    });

    ['input', 'change', 'pointermove', 'pointerup', 'touchmove', 'touchend', 'keydown', 'keyup'].forEach(function (eventName) {
      wrapper.addEventListener(eventName, scheduleSync, { passive: true });
    });
  }

  function boot() {
    document.querySelectorAll(WRAPPER_SELECTOR).forEach(observeWrapper);
    scheduleSync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.addEventListener('resize', scheduleSync);

  // ドロワーの開閉トグルは wrapper の外側にもあるため、ドキュメント側でも検知する
  ['click', 'touchend', 'keyup'].forEach(function (eventName) {
    document.addEventListener(eventName, scheduleSync, { passive: true, capture: true });
  });

  new MutationObserver(boot).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
